module.exports = __webpack_public_path__ + "img/arrow.f14eb1f4.svg";